import { render, staticRenderFns } from "./AnswerRacerStudent.vue?vue&type=template&id=2a175676"
import script from "./AnswerRacerStudent.vue?vue&type=script&lang=js"
export * from "./AnswerRacerStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports